//@ts-check
import { action, makeAutoObservable } from 'mobx';
import StatsRequests from 'Utils/Requests/StatsRequests';
import Helper from "Utils/Helper";
import { WebMetricDateRangePeriodType } from 'Stores/models/Enums';

class FiltersStore {
    initDataLoading;
    filtersValues;
    /** @type {WebStatFilters} */
    defaultFilter;
    /** @type {WebStatFilters} */
    filters;
    /** @type {WebStatFilters} */
    filtersRender;
    renderStore;
    sort;
    debug;

    constructor() {
        makeAutoObservable(this);

        this.initDataLoading = true;
        this.initDataLoaded = false;
        this.filtersValues = {};
        this.defaultFilter = {};
        this.filters = {};
        this.filtersRender = {};
        this.renderStore = {
            filterDateFrom: {},
            filterDateTo: {}
        };
        this.sort = {};
        this.debug = false;
    }

    GetInitData(funcAfter) {
        if (!this.initDataLoaded)
            StatsRequests.GetInitData().then(action(values => {
                if (values.error)
                    return;

                this.filtersValues = values.filtersValues;
                this.defaultFilter = values.defaultFilter;
                this.LoadDefaultFilters();
                this.debug = values.debug;

                this.initDataLoading = false;
                this.initDataLoaded = true;

                if (funcAfter)
                    funcAfter();
            }));
        else if (funcAfter)
            funcAfter();
    }

    LoadFiltersToRender() {
        this.filtersRender = Helper.CloneObject(this.filters);
    }

    SaveFiltersFromRender() {
        this.filters = Helper.CloneObject(this.filtersRender);
    }

    LoadDefaultFilters() {
        this.filters = Helper.CloneObject(this.defaultFilter);
        this.filtersRender = Helper.CloneObject(this.defaultFilter);
    }

    ClearFiltersRender() {
        this.filtersRender = Helper.CloneObject(this.defaultFilter);
    }

    GetSelectedFiltersCount() {
        let filters = this.filters;
        let defaultFilter = this.defaultFilter;

        return (
            (filters.dateRangePeriodType != defaultFilter.dateRangePeriodType ? 1 : 0) +
            (
                filters.dateRangePeriodType == WebMetricDateRangePeriodType.custom
                    ? (
                        (filters.dateFrom?.toJSON() != defaultFilter.dateFrom?.toJSON() ? 1 : 0) +
                        (filters.dateTo?.toJSON() != defaultFilter.dateTo?.toJSON() ? 1 : 0)
                    )
                    : 0
            )
        );
    }
}

export default new FiltersStore();